import React, { type ComponentPropsWithoutRef, type CSSProperties, forwardRef, type ReactNode } from 'react';

import { Heading } from '../Heading';

import { Styled } from './styles';

export type CellTextSubSize = 's' | 'm';

type TypoProps = {
  textOverflow?: ComponentPropsWithoutRef<typeof Heading>['textOverflow'];
  // the text renders as a heading by default: a value that does not title a section (a figure on a card) takes another tag
  textAs?: ComponentPropsWithoutRef<typeof Heading>['as'];
};
type CellTextSubProps = {
  text: ReactNode;
  sub: ReactNode;
  size?: CellTextSubSize;
  maxWidth?: CSSProperties['maxWidth'];
};
type DivProps = Omit<ComponentPropsWithoutRef<'div'>, 'children' | keyof TypoProps | keyof CellTextSubProps>;

type Props = DivProps & TypoProps & CellTextSubProps;

export const CellTextSub = forwardRef<HTMLDivElement, Props>(
  ({ text, sub, maxWidth = '100%', size = 'm', textOverflow = 'ellipsis', textAs, ...props }, ref) =>
    size === 's' ? (
      <Styled.Container {...props} maxWidth={maxWidth} ref={ref}>
        <Heading variant="heading-5" as={textAs} textOverflow={textOverflow} overflow="hidden">
          {text}
        </Heading>
        <Styled.SubText forwardedAs="p" variant="body-lighter" textOverflow={textOverflow}>
          {sub}
        </Styled.SubText>
      </Styled.Container>
    ) : (
      <Styled.Container {...props} maxWidth={maxWidth} ref={ref}>
        <Heading variant="heading-4" as={textAs} textOverflow={textOverflow} overflow="hidden">
          {text}
        </Heading>
        <Styled.SubHeading variant="heading-5" textOverflow={textOverflow}>
          {sub}
        </Styled.SubHeading>
      </Styled.Container>
    ),
);
CellTextSub.displayName = 'CellTextSub';
